<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 48 32"
  >
    <g
      :fill="color"
      class="fill-current"
    >
      <path d="M45.323 2.666c-0.567 0.001-1.093 0.178-1.525 0.481l0.009-0.006-9.143 5.826v-4.984c-0.096-2.221-1.921-3.986-4.157-3.986-0.056 0-0.112 0.001-0.167 0.003l0.008-0h-26.032c-0.047-0.002-0.103-0.003-0.159-0.003-2.236 0-4.061 1.764-4.157 3.977l-0 0.009v24.032c0.096 2.221 1.921 3.986 4.157 3.986 0.056 0 0.112-0.001 0.167-0.003l-0.008 0h26.032c0.047 0.002 0.103 0.003 0.159 0.003 2.236 0 4.061-1.764 4.157-3.977l0-0.009v-4.982l9.134 5.826c0.425 0.298 0.952 0.476 1.522 0.476 1.459 0 2.645-1.17 2.671-2.622l0-0.002v-21.417c-0.006-1.452-1.185-2.626-2.637-2.626-0.010 0-0.021 0-0.031 0h0.002zM32 28.017c-0.107 0.751-0.746 1.322-1.518 1.322-0.046 0-0.092-0.002-0.137-0.006l0.006 0h-26.035c-0.039 0.004-0.085 0.006-0.132 0.006-0.772 0-1.411-0.571-1.517-1.314l-0.001-0.008v-24.034c0.107-0.751 0.746-1.322 1.518-1.322 0.046 0 0.092 0.002 0.137 0.006l-0.006-0h26.032c0.039-0.004 0.085-0.006 0.132-0.006 0.772 0 1.411 0.571 1.517 1.314l0.001 0.008v24.032zM45.332 26.71l-0.099-0.108-10.576-6.733v-7.741l10.666-6.791z" />
    </g>

  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '22px'
    },
    height: {
      type: String,
      default: '22px'
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
